// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraphDiv {
  display: flex;
  flex-direction: row;
}
.paragraphDiv img {
  height: 550px;
}

.aboutUsPara {
  font-weight: 600;
  line-height: 20px;
}

.para {
  margin: 20px;
}

.innerParaDiv {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin-left: 30px;
  justify-content: center;
}

.aboutUs {
  margin-top: 280px;
  margin-bottom: 100px;
}

@media (max-width: 425px) {
  .aboutUs {
    margin-right: -460px;
  }

  .paragraphDiv {
    display: flex;
    flex-direction: column;
    width: fit-content;
    align-items: center;
    margin: 10px 100px;
  }
  .paragraphDiv img {
    margin-bottom: 55px;
  }

  .aboutUsPara {
    font-size: 26px;
    line-height: 38px;
  }

  .innerParaDiv {
    width: 743px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/AboutUs.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;AADJ;AAEI;EACI,aAAA;AAAR;;AAIA;EACI,gBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,oBAAA;AADJ;;AAIA;EACI;IACI,oBAAA;EADN;;EAIE;IACI,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EADN;EAGM;IACI,mBAAA;EADV;;EAKE;IACI,eAAA;IACA,iBAAA;EAFN;;EAKE;IACI,YAAA;EAFN;AACF","sourcesContent":["@import \"./variables\";\n\n.paragraphDiv{\n    display: flex;\n    flex-direction: row;\n    img{\n        height: 550px;\n    }\n}\n\n.aboutUsPara{\n    font-weight:600;\n    line-height: 20px;\n}\n\n.para{\n    margin: 20px;\n}\n\n.innerParaDiv{\n    display: flex;\n    flex-direction: column;\n    width: 500px;\n    margin-left: 30px;\n    justify-content: center;\n}\n\n.aboutUs{\n    margin-top: 280px;\n    margin-bottom:100px;\n}\n\n@media (max-width: 425px){\n    .aboutUs{\n        margin-right: -460px;\n    }\n\n    .paragraphDiv{\n        display: flex;\n        flex-direction: column;\n        width:fit-content;\n        align-items: center;\n        margin: 10px 100px;\n\n        img{\n            margin-bottom: 55px;\n        }\n    }\n\n    .aboutUsPara{\n        font-size: 26px;\n        line-height: 38px;\n    }\n\n    .innerParaDiv{\n        width: 743px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
